
import ecommerce from "./e-commerce.jpg";
import wboard from "./wboard.jpg";
const ProjectsData = [
 
  {
    name: "E-Commerce",
    desc: "An e-commerce app with simple UI which uses Commerce js API as Backend. Features like Shopping Cart, Products list are present in the App. built using Material-UI, React",
    link: "https://e-commerce.pages.dev/",
    source: "https://github.com/RajuKanaka/e-commerce",
    image: ecommerce,
  },
  {
    name: "Wboard",
    desc: "Wboard is a non-complex UI drawing App. Dynamically color and size changeble. Built using React, CSS, Canvas API",
    link: "https://wboard.pages.dev/",
    source: "https://github.com/RajuKanaka/wboard",
    image: wboard,
  },
];

export default ProjectsData;
